import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  apiVersion: null,
  isSidebarToggled: true,
  isMobileSidebarToggled: true,
  loading: false,
  fields: null,
  error: {
    display: false,
    traceback: {}
  },
  alertMessage: '',
  alertType: '',
  permissions: {
    isAdmin: false,
    allowDownload: false,
    canAccessAnalytics: false
  }
}

export default {
  namespaced: false,
  state,
  actions,
  getters,
  mutations
}
